module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n      +7\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-##-##'),
      expression: "'(###) ###-##-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.inputId,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }, function($event) {
        _vm.$emit('input', _vm.formattedPhone)
      }]
    }
  })]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small text-danger",
    class: _vm.advancedErrorClass
  }, [_vm._v("\n    " + _vm._s(_vm.errorText) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-0f58d760"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApForm/ApInputPhone.vue
// module id = 996
// module chunks = 1